var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIconUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6667 37.333C49.8367 37.333 55.6848 42.9925 55.9877 50.088L56 50.6663V55.9997C56 57.4724 54.8061 58.6663 53.3333 58.6663C51.9658 58.6663 50.8386 57.6369 50.6846 56.3107L50.6667 55.9997V50.6663C50.6667 46.4059 47.3362 42.9232 43.1367 42.6799L42.6667 42.6663H21.3333C17.0729 42.6663 13.5902 45.9968 13.3469 50.1963L13.3333 50.6663V55.9997C13.3333 57.4724 12.1394 58.6663 10.6667 58.6663C9.2991 58.6663 8.17198 57.6369 8.01794 56.3107L8 55.9997V50.6663C8 43.4963 13.6595 37.6482 20.755 37.3453L21.3333 37.333H42.6667ZM32 5.33301C39.3638 5.33301 45.3333 11.3025 45.3333 18.6663C45.3333 26.0301 39.3638 31.9997 32 31.9997C24.6362 31.9997 18.6667 26.0301 18.6667 18.6663C18.6667 11.3025 24.6362 5.33301 32 5.33301ZM32 10.6663C27.5817 10.6663 24 14.2481 24 18.6663C24 23.0846 27.5817 26.6663 32 26.6663C36.4183 26.6663 40 23.0846 40 18.6663C40 14.2481 36.4183 10.6663 32 10.6663Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconUser);
export default __webpack_public_path__ + "static/media/chat-icon-user.32b76daf92aab7e5e4fe02da099668ac.svg";
export { ForwardRef as ReactComponent };